module.exports = __webpack_public_path__ + "img/product.8928634e.png";